import '../game/game.css';

const React = require('react');
const { StageClearContainer, GamePauseContainer, GameOverContainer, GameClearContainer, StageStartContainer, ResultContainer }
    = require('../game/modal').default;
const BoardComponent = require('../game/component/boardComponent').default;
const SelectorComponent = require('../game/component/selectorComponent').default;
const InformationComponent = require('../game/component/informationComponent').default;
const timer = require('../../core/timer').default;
const gameParamater = require('../../define/gameParamater').default;
const { getClearStageScenario, getStageBonus, stageScenario } = require('../../core/stageData').default;
const style = require('../game/game.style').default;
// ============================

export default class debugComponent extends React.Component {
    componentDidMount() {
        this.props.onGameMount();
        this.interval = setInterval(this.forceUpdate.bind(this), this.props.updateInterval || 33);
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    skillTimer() {
        const { playerState = {} } = this.props;
        const { baseTime, startedAt, stoppedAt, playerSkillCoolTime, canSkill } = playerState;
        let remainingTime = 0;
        if (!canSkill) {
            const elapsedTime = timer.getElapsedTime(baseTime, startedAt, stoppedAt);
            remainingTime = playerSkillCoolTime - (elapsedTime / 1000);
            if (remainingTime < 0) {
                remainingTime = 0;
                this.props.onSkillCoolTimeEnd();
            }
        }
        return remainingTime;
    }

    render() {
        const { soundEnable } = this.props.appState;
        const { baseTime, startedAt, stoppedAt } = this.props.gameState;
        const elapsedTime = timer.getElapsedTime(baseTime, startedAt, stoppedAt);
        let remainingTime = gameParamater.REMAINING_TIME - (elapsedTime / 1000);
        if (remainingTime < 0) {
            remainingTime = 0;
            if (this.props.gameState.isGamePlaying) {
                this.props.onTimeOut();
            }
        }
        const skillRemainingTime = this.skillTimer();

        return <div style={style.gameAreaStyle}>
            <div>
                <ResultContainer />
                <GamePauseContainer />
                <StageClearContainer />
                <GameOverContainer />
                <GameClearContainer />
                <button onClick={() => this.props.onClickModal()}>MODAL</button>
                <button onClick={() => this.props.onClickButton()}>START GAME</button>
                <div style={style.informationStyle}>
                    <InformationComponent
                        soundEnable={soundEnable}
                        playerState={this.props.playerState}
                        gameState={this.props.gameState}
                        time={Math.floor(remainingTime)}
                        onPauseClick={() => { this.props.onPauseClick() }}
                        onSoundClick={() => { return }} />
                </div>
                <div style={style.boardStyle}>
                    <BoardComponent
                        state={this.props.boardState}
                        updateInterval={250}
                        isGamePlaying={this.props.gameState.isGamePlaying}
                        onDropItem={(array, frameId) => this.props.onDropPorinBox(array, frameId)}
                        onDropSkill={array => this.props.onDropSkill(array)}
                        onDeleteItem={(posX, posY) => this.props.onDeleteItem(posX, posY)}
                        onClearStage={() => {
                            getClearStageScenario(this.props.gameState.arrivalStage) === stageScenario.SCENARIO_ENDING
                                ? this.props.onClearGame()
                                : this.props.onClearStage(getStageBonus(this.props.gameState.arrivalStage))
                        }}
                        addScore={(point) => this.props.addScore(point)}
                        onChainDamage={array => this.props.onChainDamage(array)}
                    />
                </div>
                <div style={style.selectorStyle}>
                    <SelectorComponent
                        skillRemainingTime={skillRemainingTime}
                        selectorState={this.props.selectorState}
                        playerState={this.props.playerState}
                        onClickSelector={index => this.props.onClickSelector(index)} />
                </div>
            </div>
        </div>
    }
}